export default __webpack_public_path__ + "static/media/char4.5d17da6f.svg";